import React, { useEffect, useState } from "react";
import { getRenderingEngine, eventTarget } from "@cornerstonejs/core";
import { getEnv } from "../../../../helpers/EnvHelper";
import {
  CALIBRATION_APPLIED_EVENT,
  getUserCalibrationScale,
} from "../../helpers/CalibrationService";

const RENDERING_ENGINE_ID = getEnv("REACT_APP_RENDERING_ENGINE_ID");

/**
 * MedDream-style "CAL: 1 mm = X px" badge.
 *
 * Shows the user-calibration ratio for the image currently shown in this
 * viewport. The source of truth is cornerstone's calibration metadata (set by
 * CalibrationService), so the badge simply re-reads it:
 *  - when the visible image changes (currentImage prop), and
 *  - when a calibration is applied (CALIBRATION_APPLIED_EVENT).
 * Renders nothing when the image has no user calibration.
 */
const CalibrationBadge = ({ viewportIndex, currentImage }) => {
  const [scale, setScale] = useState(null);

  useEffect(() => {
    const recompute = () => {
      try {
        const re = getRenderingEngine(RENDERING_ENGINE_ID);
        const vp = re?.getViewport("viewport_" + viewportIndex);
        const imageId = vp?.getCurrentImageId?.();
        setScale(getUserCalibrationScale(imageId));
      } catch (_) {
        setScale(null);
      }
    };

    recompute();
    eventTarget.addEventListener(CALIBRATION_APPLIED_EVENT, recompute);
    return () =>
      eventTarget.removeEventListener(CALIBRATION_APPLIED_EVENT, recompute);
  }, [viewportIndex, currentImage]);

  if (!scale) return null;

  return (
    <div
      className="viewport-overlay-calibration"
      style={{
        position: "absolute",
        left: "8px",
        bottom: "8px",
        zIndex: 5,
        pointerEvents: "none",
        whiteSpace: "nowrap",
      }}
    >
      <span className="viewport-overlay-key">CAL: </span>
      <span className="viewport-overlay-value">
        1 mm = {scale.toFixed(2)} px
      </span>
    </div>
  );
};

export default CalibrationBadge;
